import React from 'react';

const LoadingAreaLegs = (props) => {
  const handleClick = (e) => {
    e.stopPropagation();
    props.context.componentParent.onClickbiddetails(props);
  };
  const indent = props.data.indent;
  console.log(indent,'ramya')
  const isDisabled =  indent.vendorquotes  && indent.vendorquotes.some(e => e.vendor_email_id === localStorage.getItem("email"));

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <button
        onClick={handleClick}
        className="ag-bid-button"
        title="Bid Now"
        disabled={isDisabled}
        style={{
          backgroundColor: isDisabled ? '#cccccc' : '#00c7b1',
          color: '#fff',
          border: 'none',
          padding: '4px 14px',
          fontSize: '13px',
          fontWeight: 500,
          borderRadius: '5px',
          lineHeight: 1.4,
          cursor: isDisabled ? 'not-allowed' : 'pointer'
        }}
      >
        Bid Now
      </button>
    </div>
  );
};

export default LoadingAreaLegs;
